import { apiClient } from "../http/httpClient";


export function ProductApi(contentType = "application/json")
{
    const http = apiClient(contentType);

    return {
  
        /**
        * @route   GET /api/products/visible
        * @desc    Récupérer uniquement les produits visibles (isVisible: true)
        * @access  Public
        * @note    Cette route doit être placée AVANT la route /:id pour éviter les conflits
        */
        findAll : () => http.get(`/api/products/visible`),

        /**
        * @route   GET /api/products/visible/:category
        * @desc    Récupérer uniquement les produits visibles (isVisible: true) d'une catégory spécifique
        * @access  Public
        * @note    Cette route doit être placée AVANT la route /:id pour éviter les conflits
        */
        findAllByCategory : (category) => http.get(`/api/products/visible/${category}`),
        
        /**
        * @route   GET /api/products/:id
        * @desc    Récupérer un produit spécifique avec ses images et créateur
        * @access  Public
        * @param   {integer} id - Identifiant du produit
        */
        findOne: (id) => http.get(`/api/products/${id}`),

      };
}

